import { NavLink } from "react-router-dom";
import {
  CContainer,
  CHeader,
  CHeaderBrand,
  CHeaderDivider,
  CHeaderNav,
  CHeaderToggler,
  CNavLink,
  CNavItem,
} from "@coreui/react-pro";
import { cilApplicationsSettings, cilMenu } from "@coreui/icons-pro";
import CIcon from "@coreui/icons-react";
import CoreUiBreadcrumb from "./widgets/CoreUiBreadcrumb";
import CoreUiThemeSwitcher from "./widgets/CoreUiThemeSwitcher";
import { CoreUiRoutePath } from "../../../configs/_coreui.route-path";
import { useCoreUiHeaderController } from "../controllers/useCoreUiHeaderController";
import { logo as starterLogo } from "../../../../assets/brand/coreui-logo-header";
import {
  AppHeaderDropdown,
  AppHeaderDropdownMssg,
  AppHeaderDropdownNotif,
  AppHeaderDropdownTasks,
} from "./widgets";

const CoreUiHeader = (): JSX.Element => {
  const {
    state: { sidebarShow, asideShow },
    action: { setSidebarShow, setAsideShow },
  } = useCoreUiHeaderController();

  return (
    <CHeader position="sticky" className="mb-4">
      <CContainer fluid>
        <CHeaderToggler
          className="ps-1"
          onClick={() => setSidebarShow(!sidebarShow)}
        >
          <CIcon icon={cilMenu} size="lg" />
        </CHeaderToggler>
        <CHeaderBrand className="mx-auto d-md-none">
          <CIcon icon={starterLogo} height={48} aria-valuetext="Logo" />
        </CHeaderBrand>
        <CHeaderNav className="d-none d-md-flex me-auto">
          <CNavItem>
            <CNavLink to={CoreUiRoutePath.Dashboard} component={NavLink}>
              Dashboard
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink href="#">Users</CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink to={"/"} component={NavLink}>
              Main
            </CNavLink>
          </CNavItem>
        </CHeaderNav>
        <CHeaderNav className="ms-auto me-4">
          <CoreUiThemeSwitcher />
        </CHeaderNav>
        <CHeaderNav>
          <AppHeaderDropdownNotif />
          <AppHeaderDropdownTasks />
          <AppHeaderDropdownMssg />
        </CHeaderNav>
        <CHeaderNav className="ms-2 me-2">
          <AppHeaderDropdown />
        </CHeaderNav>
        <CHeaderToggler
          className="px-md-0 me-md-3"
          onClick={() => setAsideShow(!asideShow)}
        >
          <CIcon icon={cilApplicationsSettings} size="lg" />
        </CHeaderToggler>
      </CContainer>
      <CHeaderDivider />
      <CContainer fluid>
        <CoreUiBreadcrumb />
      </CContainer>
    </CHeader>
  );
};

export default CoreUiHeader;
